import {
  convertToServicepointVendorAddressDto,
  type ServicepointVendor,
  type ServicepointVendorDto,
} from '~/modules/servicepointvendors/model'

export const convertToServicepointVendorDto = (servicepoint: ServicepointVendor): ServicepointVendorDto => ({
  ...servicepoint,
  address: convertToServicepointVendorAddressDto(servicepoint.address),
})
